import React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
import { SVGComponent } from '@tools/ui/types';

type IProps = {
  style?: React.CSSProperties;
  onClick?: (e: any) => void;
  component: unknown;
};

export const ExpandIconWrap: React.FC<IProps> = ({
  style,
  onClick,
  component
}) => {
  const defaultStyle = { fontSize: 11, ...style };

  return (
    <Icon
      component={component as SVGComponent}
      style={defaultStyle}
      onClick={onClick}
    />
  );
};
